import React from 'react';
import LogsTable from '../../components/LogsTable/LogsTable';
import LogsManagement from '../../components/LogsManagement/LogsManagement';
import { useAppDispatch, useAppSelector } from 'store/hook';
import classes from './Logs.module.scss';
import { fetchAvailableLogs } from 'store/reducers/logsCreator';
import { useNavigate, useParams } from 'react-router';
import { setSelectedKeys } from 'store/slices/windowStateSlice';
import { useTranslation } from 'react-i18next';
import { setLogsForPrint } from 'store/slices/dataLogsSlice';
import { setDocuments } from 'store/slices/dataDocumentsSlice';

const Logs = () => {
  const dispatch = useAppDispatch();
  const navigate = useNavigate();
  const params = useParams();

  const { dataRoom, isLoadingRoom } = useAppSelector((store) => store.dataRoom);
  const { logs, isLoadingLogs, isForceUpdating, errorLogs } = useAppSelector((store) => store.logs);
  const { userPermissions, userData, userAndRoomStatus } = useAppSelector((store) => store.userData);
  const { messageApi } = useAppSelector((store) => store.windowState);

  const { i18n, t } = useTranslation()
  const locale = i18n.language || 'en'
  
  React.useEffect(() => {
    if (userData?.id && !userAndRoomStatus) {
      if (!userPermissions?.can_view_logs) {
        navigate(`/room/${dataRoom?.custom_url || dataRoom?.id || params.room}/documents`);
      }
    }
  }, [userPermissions, userAndRoomStatus]);

  React.useEffect(() => {
    dispatch(setDocuments({documents: [], folders: []}));
    
    dispatch(setSelectedKeys(['logs']));
    window.scroll(0, 0);
    dataRoom?.id && dispatch(fetchAvailableLogs({ roomId: dataRoom?.id, locale }));

    return () => {
      dispatch(setLogsForPrint([]))
    }
  }, [dataRoom?.id, locale]);

  React.useEffect(() => {
    errorLogs && messageApi?.error(t('Logs.errorDownloading'));
  }, [errorLogs]);
  
  return (
    <div className={classes.tableWrapper}>
      <div className={classes.subWrapper}>
        <LogsManagement />

        <LogsTable
          logs={logs}
          isLoading={isLoadingLogs || isLoadingRoom || userAndRoomStatus !== ''}
          virtual={true}
          scroll={{
            y: window.innerHeight - 204,
            x: 800,
          }}
          isUdating={isForceUpdating}
        />
      </div>
    </div>
  );
};

export default Logs;
